import { PageInfo } from '@generated/schema';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface States {
  filterMemberName: string;
  isGridReady: boolean;
  listMembersEndCursor: string;
  listMembersPageNumber: number;
  listMembersPageSize: number;
  listMembersRowIndex: number;
  pageInfo: PageInfo | null | undefined;
  recordLoaded: number;
}

const initialState: States = {
  filterMemberName: '',
  isGridReady: false,
  listMembersEndCursor: '',
  listMembersPageNumber: 0,
  listMembersPageSize: 100,
  listMembersRowIndex: -1,
  pageInfo: null,
  recordLoaded: 0,
};

export const membersListLessonNoteMembersSlice = createSlice({
  initialState,
  name: 'membersListLessonNoteMembers',
  reducers: {
    setFilterMemberName: (state, { payload }: PayloadAction<string>) => {
      state.filterMemberName = payload;
    },
    setIsGridReady: (state, { payload }: PayloadAction<boolean>) => {
      state.isGridReady = payload;
    },
    setListMembersEndCursor: (state, { payload }: PayloadAction<string>) => {
      state.listMembersEndCursor = payload;
    },
    setListMembersPageNumber: (state, { payload }: PayloadAction<number>) => {
      state.listMembersPageNumber = payload;
    },
    setListMembersPageSize: (state, { payload }: PayloadAction<number>) => {
      state.listMembersPageSize = payload;
    },
    setListMembersRowIndex: (state, { payload }: PayloadAction<number>) => {
      state.listMembersRowIndex = payload;
    },
    setPageInfo: (state, { payload }: PayloadAction<PageInfo>) => {
      state.pageInfo = payload;
    },
    setRecordLoaded: (state, { payload }: PayloadAction<number>) => {
      state.recordLoaded = payload;
    },
  },
});

export default membersListLessonNoteMembersSlice.reducer;

export const {
  setFilterMemberName: setFilterMemberNameAction,
  setIsGridReady: setIsGridReadyAction,
  setListMembersEndCursor: setListMembersEndCursorAction,
  setListMembersPageNumber: setListMembersPageNumberAction,
  setListMembersPageSize: setListMembersPageSizeAction,
  setListMembersRowIndex: setListMembersRowIndexAction,
  setPageInfo: setPageInfoAction,
  setRecordLoaded: setRecordLoadedAction,
} = membersListLessonNoteMembersSlice.actions;
